/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Music_NoteInputs */



/**
* | output |
* | --- |
* | "Insert single music note" |
*
* @param {Shortcut_Keys_Desc_Insert_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_music_note = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer une note de musique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge eine einzelne Musiknote ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci una singola nota musicale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте отдельную музыкальную ноту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar una sola nota musical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入一个音符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単一の音符を挿入する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकल संगीत नोट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir uma única nota musical")
	return /** @type {LocalizedString} */ ("Insert single music note")
});